<template>
  <ds-data-grid-tr
    :key="index"
    :item="intern"
    :confirm-button-label="deleteTextButton"
    :confirm-title="deleteTextTitle"
    :edit-action="editAction"
    :custom-actions="customActions"
    :view-action="viewAction">
    <ds-td>
      {{ intern.registration }}
    </ds-td>
    <ds-td>
      {{ intern.internName }}
    </ds-td>
    <ds-td>
      {{ intern.cpf | caCpf }}
    </ds-td>
    <ds-td>
      {{ intern.internCategory ? intern.internCategory.description : '-' }}
    </ds-td>
    <ds-td>
      {{ intern.beginDate | caDate }}
    </ds-td>
    <ds-td>
      {{ intern.endDate | caDate }}
    </ds-td>
  </ds-data-grid-tr>
</template>
<script>
import { confirmService, toasterService } from 'packages/common/ds-components';
import { DELETE_BUTTON, DELETE_MESSAGE, DELETE_TITLE } from './constants';
import { deleteIntern } from './internService';

export default {
  name: 'InternsPageTableItem',
  props: {
    index: {
      type: Number,
      required: true,
    },
    intern: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      customActions: [{
        name: 'Opções de Cálculo',
        action: this.onOptions,
      }, {
        name: 'Excluir',
        action: this.removeAction,
      }],
      deleteTextButton: DELETE_BUTTON,
      deleteContentModal: DELETE_MESSAGE,
      deleteTextTitle: DELETE_TITLE,
    };
  },
  methods: {
    viewAction({ id }) {
      this.$router.push({ name: 'ViewIntern', params: { id } });
    },
    editAction({ id }) {
      this.$router.push({ name: 'EditIntern', params: { id } });
    },
    onOptions({ id }) {
      this.$router.push({ name: 'EditInternOptions', params: { id } });
    },
    removeAction({ id }) {
      confirmService.confirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        onConfirm: () => {
          deleteIntern(id)
            .then(() => {
              this.$emit('on-update-list');
              toasterService.success({
                title: 'Sucesso',
                content: 'Estagiário foi excluído.',
              });
            })
            .catch(() => toasterService.error({
              title: 'Erro',
              content: 'Não foi possível excluir o estagiário.',
            }));
        },
      });
    },
  },
};
</script>
